@if (model()) {
  <div>
    <div class="overview-panel">
      <div class="row header">
        <div class="col col-12">
          <div class="row">
            <div class="col-3 col-md-2 col-lg-1 order-1 icon-column">
              @if (model()?.headerIcon) {
                <i [ngClass]="model()?.headerIcon" class="fa-3x"></i>
              }
            </div>

            <div class="col-8 col-md-9 col-lg-10 order-2 additional-margin-top">
              @if (model()?.headerTitle) {
                <h4 [innerHtml]="model()?.headerTitle"></h4>
              }
              @if (model()?.headerSubtitle) {
                <h5 class="portal-text" [innerHtml]="model()?.headerSubtitle"></h5>
              }
            </div>
            @if (!model()?.hideUrlIcon) {
              <div class="col-1 order-3" style="text-align: end">
                @if (model()?.headerRoutingUrl) {
                  <a class="btn" [routerLink]="model()?.headerRoutingUrl" queryParamsHandling="merge">
                    <i style="margin-right: 4px" class="fas fa-chevron-right"></i>
                  </a>
                } @else {
                  <a class="btn" [href]="model()?.headerLinkUrl">
                    <i style="margin-right: 4px" class="fas fa-chevron-right"></i>
                  </a>
                }
              </div>
            }
          </div>
        </div>
      </div>

      <div class="row content" style="flex: 2">
        <div class="col col-12 content-container">
          <div class="container infinity-horizontal" style="height: 100%">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>
}
